import { Toast } from '../../services/models/toast.model';

export class CreateToast {
  static readonly type = '[Toasts] - Create';

  constructor(public toast: Partial<Toast>) {}
}

export class RemoveToast {
  static readonly type = '[Toasts] - Remove';

  constructor(public id: string) {}
}
